
var SettingsConstants = {
    APP_DEFAULT_STATE: 'wellcome',
    APP_SEARCH_RESULTS_STATE: 'searchresults',
    APP_HTTP_BACKEND: false
};

module.exports = SettingsConstants;



